module.exports = __webpack_public_path__ + "assets/img/member.b49b13a0.jpg";